import React, { useState } from 'react';
import Axios from 'axios';
import { servicios_grupogack, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import ModalService from '../../../ModalService/ModalService';
import FormPuestos from './FormPuestos'; 
import { JsonPuestos } from '../../../Helpers/JsonToOneLevel';

const ModalAddPuestos = ({ openAdd, setOpenAdd, agregar, errorTable, nombreModulo }) => {
    
    const [ error, setError ] = useState( null );

    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarPuesto = puesto => {
        const info = { nivlaboral: puesto.nivlaboral, puestoCve: puesto.puestoCve, puestoNom: puesto.puestoNom,
                       puestoDescrip: puesto.puestoDescrip, relabid: puesto.relabid  };
        Axios.post(`${servicios_grupogack}/org/puesto/`, info, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    agregar(JsonPuestos(res.data.dataResponse));
                    setOpenAdd( false );
                    break;
                default:
                    errorTable(registro_no_guardado);
                    break;
            }
        })
        .catch(error => errorTable(registro_no_guardado));
    }

    return (
        <ModalService title="Nuevo Puesto" parentNode={nombreModulo}
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
            <div className="row">
                <div className="col-12">
                    <FormPuestos
                        enviarPuesto={enviarPuesto}
                        error={error}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalAddPuestos;